import { render, staticRenderFns } from "./TestPackageSort.vue?vue&type=template&id=8076e92a"
import script from "./TestPackageSort.vue?vue&type=script&lang=js"
export * from "./TestPackageSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports